import React from 'react';

import { PersonalAccessToken } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { PersonalAccessToken as PersonalAccessTokenType } from '@ragu-components/ord-types';

const PersonalAccessTokensList = React.lazy(async () => import('./PersonalAccessTokensList'));

export const personalAccessTokensResource: OrdResourceProps = {
  key: `me/${PersonalAccessToken}`,
  name: `me/${PersonalAccessToken}`,
  list: <PersonalAccessTokensList />,
  options: {},
  recordRepresentation: (record: PersonalAccessTokenType): string => record.name,
};
